import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/constants";
import { useNavigate } from "react-router-dom";

export default function ReviewsQueue() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/reviews");
        setReviews(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <p className="overline mb-1 text-muted-foreground">Stage 5 · Ongoing Review</p>
        <h1 className="font-dashboard text-3xl font-bold tracking-tight">Reviews due</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Scheduled annual reviews and life-event triggered reviews for your book.
        </p>
      </div>

      <Card className="border-border bg-white">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px] text-sm">
            <thead>
              <tr className="border-b border-border bg-secondary/40 text-left text-xs uppercase tracking-wider text-muted-foreground">
                <th className="px-4 py-3">Trigger</th>
                <th className="px-4 py-3">Life event</th>
                <th className="px-4 py-3">Due</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody data-testid="reviews-queue-body">
              {loading ? (
                <tr><td colSpan={4} className="px-4 py-10 text-center text-muted-foreground">Loading…</td></tr>
              ) : reviews.length === 0 ? (
                <tr><td colSpan={4} className="px-4 py-16 text-center text-muted-foreground">No reviews pending. Great.</td></tr>
              ) : reviews.map((r) => (
                <tr key={r.id} className="border-b border-border last:border-0 hover:bg-secondary/20" data-testid={`review-row-${r.id}`}>
                  <td className="px-4 py-4 font-medium">{r.trigger_type}</td>
                  <td className="px-4 py-4 text-muted-foreground">{r.life_event_type || "—"}</td>
                  <td className="px-4 py-4">{formatDate(r.due_date)}</td>
                  <td className="px-4 py-4 text-right">
                    <Button size="sm" variant="outline" onClick={() => navigate(`/app/clients/${r.client_id}`)} data-testid={`open-client-${r.client_id}`}>Open client</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
